export interface ILicenseRequest {
    deviceId: string;
    deviceSource: DeviceSource;
    user: string;
}

export interface ILicenseResponse {
    deviceId: string;
    active: boolean;
}

export interface ILicenseUsage {
    usedLicenses: number;
    totalLicenses: number;
}

export enum DeviceSource {
    FOP = 'FOP',
    MOP = 'MOP'
}
